// This mixin expects that your component will have an element in it
// with tabindex="-1" and a reference with the value elementReferenceName,
export default function (elementReferenceName, hash) {
  return {
    watch: {
      $route: 'focusElementOnRouteChange'
    },
    mounted() {
      this.focusContainer(this.$route)
    },
    methods: {
      focusContainer(route) {
        if (route.hash === hash) {
          this.getReference(this.$refs, elementReferenceName).focus()
          // remove the hash so that the element will not be focused after page reload
          this.$router.replace({ ...route, hash: null })
        }
      },
      focusElementOnRouteChange(to, from) {
        this.focusContainer(to)
      },
      getReference(object, elementReferenceName) {
        if (Array.isArray(elementReferenceName)) {
          if (elementReferenceName.length === 1) {
            return object[elementReferenceName[0]]
          } else {
            return this.getReference(object[elementReferenceName[0]], elementReferenceName.slice(1))
          }
        } else {
          return object[elementReferenceName]
        }
      }
    }
  }
}
